import { useContext, useState, useEffect } from "react"
import { Button, Typography } from "@mui/material"
import Grid from "@mui/material/Unstable_Grid2/Grid2"

import OneInput from '../../../Components/OneInput/OneInput'
import { WebSocketContext } from "../../../Providers/WebSocket/WebSocketContext"
import { showNotify } from '../../../Utils/Utils'
import OneModal from "../../../Components/OneModal/OneModal"
import { UserContext } from '../../../Providers/UserContext/UserContex'
import ComboBox from "../../../Components/ComboBox/ComboBox"

export const ModalGerarEvento = ({ openGerarEvento, setOpenGerarEvento, idCondAtivo, nomeCondAtivo }) => {
    const { addRoute, sendWs } = useContext(WebSocketContext)
    const { user, check } = useContext(UserContext)

    const [initialData, setInitialData] = useState(null)
    const [loading, setLoading] = useState(true)
    const [formData, setFormData] = useState()

    const getEventos = (msg) => {
        if (msg.data.status) {
            const eventosManuais = msg.data.listagens.eventoManual.map(evento => {
                evento.descricao = `${evento.evento} - ${evento.descricao}`
                return evento
            })

            setInitialData(eventosManuais)
            setLoading(false)
        } else {
            showNotify(msg.message)
            setOpenGerarEvento(false)
        }
    }

    useEffect(() => {
        setLoading(true)
        addRoute("buscarListagens", getEventos)
        sendWs("buscarListagens", { listagens: { eventoManual: ["evento", "descricao"] } })
    }, [])

    const responseSumbit = (msg) => {
        if (msg.data.status == "error" || !msg.data.status) {
            showNotify("error", msg.data.message)
        } else {
            setOpenGerarEvento(false)
            showNotify("success", "Evento gerado com sucesso!")
        }
    }

    addRoute("gerarEventoManual", responseSumbit)

    const handleChange = (event) => {
        if (event.target.value != undefined) {
            setFormData({ ...formData, [event.target.name]: event.target.value })
        }
    }

    const handleSubmit = (event) => {
        event.preventDefault()
        if (!formData) {
            showNotify("warning", "Nenhuma alteração feita!")
            return
        }
        let { evento, auxiliar } = formData

        if (!evento) {
            showNotify('warning', 'O campo evento é obrigatório.')
            return
        }

        if (auxiliar && auxiliar.length > 5) {
            showNotify('warning', 'O campo auxiliar excedeu o limite de 5 caracteres.')
            return
        }

        const ramal = check.estado_jornada == 1 ? check.ramal : false

        sendWs("gerarEventoManual", { id_central: idCondAtivo, evento, auxiliar, nomeUsuario: user.nome, idUsuario: user.id, ramal })
    }

    return (
        <OneModal
            open={openGerarEvento}
            setOpen={setOpenGerarEvento}
            loading={loading}
            titleText="Gerar Evento Manual"
            FooterButtons={FooterButtons}
        >
            {!loading &&
            <form
                id="manual-form"
                onSubmit={handleSubmit}
            >
                <Grid
                    container
                    xs={12}
                    rowGap={2}
                    columnSpacing={1}
                    sx={{ alignItems: 'center', maxWidth: '600px' }}
                >
                    <Grid container xs={12}>
                        <Grid xs={12} sm={2} lg={2}>
                            <Typography fontSize="13px" fontWeight='400' >Condomínio: </Typography>
                        </Grid>
                        <Grid xs={12} sm lg>
                            <OneInput
                                defaultValue={`${idCondAtivo} - ${nomeCondAtivo}`}
                                disabled={true}
                            />
                        </Grid>
                    </Grid>
                    <Grid container xs={12}>
                        <Grid xs={12} sm={2} lg={2}>
                            <Typography fontSize="13px" fontWeight='400' >*Evento: </Typography>
                        </Grid>
                        <Grid xs={12} sm lg>
                            <ComboBox
                                options={initialData}
                                onChange={handleChange}
                                label='descricao'
                                valor='evento'
                                name='evento'
                            />
                        </Grid>
                    </Grid>
                    <Grid container xs={12}>
                        <Grid xs={12} sm={2} lg={2}>
                            <Typography fontSize="13px" fontWeight='400' >Auxiliar: </Typography>
                        </Grid>
                        <Grid xs={12} sm lg>
                            <OneInput
                                name={"auxiliar"}
                                onChange={handleChange}
                                maxLength='5'
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </form>
            }
        </OneModal>
    )
}

export const FooterButtons = () => {
    return (
        <Grid container xs={12} sx={{ alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
            <span style={{ fontSize: '13px', margin: 0, padding: 0 }}>* Campos obrigatórios!</span>
            <Button color="one_primary" variant="contained" form="manual-form" type="submit">Gerar</Button>
        </Grid>
    )
}
